<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Prestadores de Salud</h4>
    <hr />

    <DataTable
      :data="prestadors"
      :columns="columnas"
      idField="idPrestador"
      mensajeVacio="No hay prestadores registrados."
      :mostrarBotonNuevo="true"
      :mostrarEditar="true"
      :mostrarVer="true"
      :mostrarEliminar="false"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idPrestador)"
      @view="row => abrirEditar(row.idPrestador)"
      @delete="row => deletePrestador(row.idPrestador)"
    >
      <!-- ── Búsquedas en la barra de acciones ─────────────────── -->
      <template #acciones-extra>
        <!-- RUC -->
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="rucBusqueda"
            placeholder="RUC..."
            style="width:130px"
            @keyup.enter="getDataRUC"
          />
          <button class="btn btn-outline-secondary btn-sm" @click="getDataRUC" title="Buscar RUC">
            <span class="material-icons" style="font-size:14px">search</span>
          </button>
        </div>
        <!-- Razón Social -->
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="razonSocialBusqueda"
            placeholder="Razón social..."
            style="width:200px; text-transform:uppercase"
            @keyup.enter="getDataRazonSocial"
          />
          <button class="btn btn-outline-secondary btn-sm" @click="getDataRazonSocial" title="Buscar razón social">
            <span class="material-icons" style="font-size:14px">search</span>
          </button>
        </div>
        <!-- Nombre Comercial -->
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreComercialBusqueda"
            placeholder="Nombre comercial..."
            style="width:200px; text-transform:uppercase"
            @keyup.enter="getDataNombreComercial"
          />
          <button class="btn btn-outline-secondary btn-sm" @click="getDataNombreComercial" title="Buscar nombre comercial">
            <span class="material-icons" style="font-size:14px">search</span>
          </button>
        </div>
      </template>

      <!-- ── Celda nivel legible ────────────────────────────────── -->
      <template #cell-nivel="{ row }">
        <span class="badge" :class="badgeNivel(row.nivel)">
          {{ labelNivel(row.nivel) }}
        </span>
      </template>

      <!-- ── Celda sábado/domingo ───────────────────────────────── -->
      <template #cell-sabado="{ row }">
        <span class="material-icons" :style="{ color: row.sabado == 1 ? 'green' : '#ccc', fontSize: '18px' }">
          {{ row.sabado == 1 ? 'check_circle' : 'cancel' }}
        </span>
      </template>
      <template #cell-domingo="{ row }">
        <span class="material-icons" :style="{ color: row.domingo == 1 ? 'green' : '#ccc', fontSize: '18px' }">
          {{ row.domingo == 1 ? 'check_circle' : 'cancel' }}
        </span>
      </template>

      <!-- ── Acciones extra por fila ────────────────────────────── -->
      <template #acciones-fila="{ row }">
        <button
          class="btn btn-sm btn-outline-secondary"
          @click="abrirPrestador(row.idPrestador)"
          title="Ficha del prestador"
        >
          <span class="material-icons" style="font-size:14px">badge</span>
        </button>
      </template>
    </DataTable>

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- Razón Social -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Razón Social</label>
                  </div>
                  <div class="col-10">
                    <textarea
                      class="form-control"
                      v-model="datoPrestador.razonSocial"
                      style="text-transform:uppercase"
                      rows="2"
                    ></textarea>
                  </div>
                </div>
              </div>
              <!-- Nombre Comercial -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Nombre Comercial</label>
                  </div>
                  <div class="col-10">
                    <textarea
                      class="form-control"
                      v-model="datoPrestador.nombreComercial"
                      style="text-transform:uppercase"
                      rows="2"
                    ></textarea>
                  </div>
                </div>
              </div>
              <!-- RUC + Nivel -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">RUC</label>
                  </div>
                  <div class="col-4">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoPrestador.ruc"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                  <div class="col-2">
                    <label class="form-label fw-bold">Nivel</label>
                  </div>
                  <div class="col-4">
                    <select class="form-select" v-model="datoPrestador.nivel" required>
                      <option value="1">Primer Nivel</option>
                      <option value="2">Segundo Nivel</option>
                      <option value="3">Tercer Nivel</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Frecuencia + Sábado + Domingo -->
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-2">
                    <label class="form-label fw-bold">Frecuencia de carga</label>
                  </div>
                  <div class="col-2">
                    <select class="form-select" v-model="datoPrestador.frecuenciaCarga">
                      <option value="M">Mensual</option>
                      <option value="S">Semanal</option>
                    </select>
                  </div>
                  <div class="col-2">
                    <label class="form-label fw-bold mb-0">Trabaja el sábado</label>
                  </div>
                  <div class="col-1">
                    <input type="checkbox" class="form-check-input" v-model="datoPrestador.sabado" />
                  </div>
                  <div class="col-2">
                    <label class="form-label fw-bold mb-0">Trabaja el domingo</label>
                  </div>
                  <div class="col-1">
                    <input type="checkbox" class="form-check-input" v-model="datoPrestador.domingo" />
                  </div>
                </div>
              </div>
              <!-- Info auditoría (solo edición) -->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">ID</label></div>
                  <div class="col-2">
                    <div class="form-control-plaintext">{{ datoPrestador.idPrestador }}</div>
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Fecha Registro</label></div>
                  <div class="col-2">
                    <div class="form-control-plaintext">{{ getFormattedDate(datoPrestador.fechaReg) }}</div>
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Fecha Actualización</label></div>
                  <div class="col-2">
                    <div class="form-control-plaintext">{{ getFormattedDate(datoPrestador.fechaAct) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarPrestador"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarPrestador"
              v-if="btnEditar"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat      from "@/modules/dateFormat.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  name: "PrestadorList",
  components: { Layout, Footer, DataTable },

  data() {
    return {
      prestadors:              [],
      datoPrestador:           {},
      rucBusqueda:             "",
      razonSocialBusqueda:     "",
      nombreComercialBusqueda: "",
      titulo:                  "",
      btnCrear:                false,
      btnEditar:               false,
      modalWindow:             true,
      idEmpresa:               0,
    };
  },

  computed: {
    columnas() {
      return [
        { label: "RUC",             field: "ruc"            },
        { label: "Razón Social",    field: "razonSocial"    },
        { label: "Nombre Comercial",field: "nombreComercial"},
        // nivel, sabado y domingo usan slots #cell-*
        { label: "Nivel",           field: "nivel"          },
        { label: "Sáb.",            field: "sabado"         },
        { label: "Dom.",            field: "domingo"        },
      ];
    },
  },

  mounted() {
    this.idEmpresa = window.sessionStorage.getItem("idEmpresa");
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.getData();
  },

  methods: {
    // ── Utilidades ────────────────────────────────────────────
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },

    labelNivel(nivel) {
      const map = { 1: "Primer Nivel", 2: "Segundo Nivel", 3: "Tercer Nivel" };
      return map[nivel] ?? "";
    },

    badgeNivel(nivel) {
      return {
        "bg-success":           nivel == 1,
        "bg-primary":           nivel == 2,
        "bg-warning text-dark": nivel == 3,
        "bg-secondary":         ![1, 2, 3].includes(Number(nivel)),
      };
    },

    // ── Carga de datos ────────────────────────────────────────
    getData() {
      this.rucBusqueda             = "";
      this.razonSocialBusqueda     = "";
      this.nombreComercialBusqueda = "";
      api.get(`/vwprestadors/idempresa/${this.idEmpresa}`)
        .then(r => { this.prestadors = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar prestadores:", e));
    },

    getDataRUC() {
      if (!this.rucBusqueda.trim()) { this.getData(); return; }
      api.get(`/vwprestadors/idempresa-ruc/${this.idEmpresa}/${this.rucBusqueda}`)
        .then(r => { this.prestadors = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al buscar por RUC:", e));
    },

    getDataRazonSocial() {
      if (!this.razonSocialBusqueda.trim()) { this.getData(); return; }
      api.get(`/vwprestadors/idempresa-razonsocial/${this.idEmpresa}/${this.razonSocialBusqueda}`)
        .then(r => { this.prestadors = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al buscar por razón social:", e));
    },

    getDataNombreComercial() {
      if (!this.nombreComercialBusqueda.trim()) { this.getData(); return; }
      api.get(`/vwprestadors/idempresa-nombrecomercial/${this.idEmpresa}/${this.nombreComercialBusqueda}`)
        .then(r => { this.prestadors = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al buscar por nombre comercial:", e));
    },

    // ── Conversión checkboxes ─────────────────────────────────
    enviarCheckboxes() {
      this.datoPrestador.sabado  = this.datoPrestador.sabado  ? "1" : "0";
      this.datoPrestador.domingo = this.datoPrestador.domingo ? "1" : "0";
    },

    consultarCheckBoxes() {
      this.datoPrestador.sabado  = this.datoPrestador.sabado  == "1";
      this.datoPrestador.domingo = this.datoPrestador.domingo == "1";
    },

    // ── Validación ────────────────────────────────────────────
    validarForm() {
      return validarForm(
        this.datoPrestador,
        ["razonSocial", "nombreComercial", "ruc"],
        ["Razón Social", "Nombre Comercial", "RUC"]
      );
    },

    // ── CRUD ──────────────────────────────────────────────────
    async guardarPrestador() {
      if (this.validarForm() !== 1) return;
      try {
        this.enviarCheckboxes();
        this.datoPrestador.idEmpresa = this.idEmpresa;
        await api.post("/prestadors", this.datoPrestador);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Prestador creado exitosamente." });
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async actualizarPrestador() {
      if (this.validarForm() !== 1) return;
      try {
        this.enviarCheckboxes();
        await api.post("/prestadors", this.datoPrestador);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Prestador actualizado exitosamente." });
        this.getData();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    async deletePrestador(idPrestador) {
      const confirm = await Swal.fire({
        title:             "¿Eliminar prestador?",
        text:              "Esta acción no se puede deshacer.",
        icon:              "warning",
        showCancelButton:  true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText:  "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/prestadors/" + idPrestador);
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Modales y navegación ──────────────────────────────────
    abrirModalCrear() {
      this.modalWindow   = true;
      this.datoPrestador = {};
      this.titulo        = "Crear Prestador";
      this.btnCrear      = true;
      this.btnEditar     = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(idPrestador) {
      this.modalWindow = true;
      this.titulo      = "Editar Prestador";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp         = await api.get("/vwprestadors/" + idPrestador);
        this.datoPrestador = resp.data;
        this.consultarCheckBoxes();
      } catch (e) {
        console.error("Error al cargar prestador:", e);
        return;
      }
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    abrirEditar(idPrestador) {
      if (idPrestador != null) this.$router.push("/prestador_elempres/" + idPrestador);
    },

    abrirPrestador(idPrestador) {
      if (idPrestador != null) this.$router.push("/prestadorform/" + idPrestador);
    },
  },
};
</script>